import React from 'react';
import { Box } from '@mui/material';
import { useDarkMode } from '../contexts/DarkModeContext';

/**
 * Markenzo Worldwide logos (theme-aware).
 * - light UI → image2.png (magenta logo)
 * - dark UI → markenzo-dark.png (white + pink logo)
 * Legacy MARK icon variants remain available.
 */
const LOGO_SRC = {
  light: '/image2.png',
  dark: '/markenzo-dark.png',
  // legacy MARK icons
  white: '/mark-white.png',
  color: '/mark-color.png',
  whiteBox: '/mark-white-box.png',
  blackBox: '/mark-black-box.png',
  icon: '/logo-only.png',
};

const MarkLogo = ({
  variant = 'auto', // auto | light | dark | icon | white | color | whiteBox | blackBox
  height = 36,
  width = 'auto',
  forceDark = null, // true = dark bg UI, false = light bg UI, null = theme
  alt = 'Markenzo Worldwide',
  animate = false,
  sx = {},
  ...rest
}) => {
  const { isDarkMode } = useDarkMode();
  const darkBg = forceDark === null ? isDarkMode : forceDark;

  let src;
  if (variant === 'auto') {
    src = darkBg ? LOGO_SRC.dark : LOGO_SRC.light;
  } else {
    src = LOGO_SRC[variant] || LOGO_SRC.light;
  }

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        height,
        width,
        maxWidth: '100%',
        objectFit: 'contain',
        display: 'block',
        background: 'transparent',
        userSelect: 'none',
        ...sx,
      }}
      {...rest}
      className={animate ? 'mark-logo-live' : rest.className}
    />
  );
};

export { LOGO_SRC };
export default MarkLogo;
